'use client';

import { Box } from '@wishket/design-system';
import { twJoin } from 'tailwind-merge';
import { Suspense } from 'react';

import { PersonalDataCounts } from './PersonalDataCounts';
import { PersonalDataProfile } from './PersonalDataProfile';
import PersonalDataHeaderSkeleton from './parts/PersonalDataHeaderSkeleton';

import { useProfile } from '@/shared/hooks';

const PersonalDataHeader = () => {
  const { profile } = useProfile();

  const yozmitProfileId = profile?.yozmitProfileId;
  const name = profile?.name;
  const roleKor = profile?.roleKor;
  const hasProfileProps = !!yozmitProfileId && !!name && !!roleKor;

  if (!hasProfileProps) return <PersonalDataHeaderSkeleton />;

  return (
    <Suspense fallback={<PersonalDataHeaderSkeleton />}>
      <Box
        className={twJoin(
          'flex flex-col gap-6 px-5',
          'tablet:flex-row tablet:justify-between desktop:px-8'
        )}
      >
        <PersonalDataProfile
          yozmitProfileId={yozmitProfileId}
          imgSrc={profile?.imgSrc}
          name={name}
          roleKor={roleKor}
        />
        <PersonalDataCounts />
      </Box>
    </Suspense>
  );
};

export default PersonalDataHeader;
